import React from 'react';

import { designTokens } from '../theme/tokens';

type PanelProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
};

export function Panel({ title, subtitle, children }: PanelProps) {
  return (
    <section
      style={{
        border: 0,
        borderRadius: designTokens.radius.xl,
        padding: designTokens.spacing.md,
        background: designTokens.colors.surfaceContainerLowest,
        boxShadow: designTokens.shadows.card,
        minWidth: 0,
      }}
    >
      <h2
        style={{
          ...designTokens.typography.headlineMd,
          color: designTokens.colors.onSurface,
          marginTop: 0,
          marginBottom: designTokens.spacing.xs,
        }}
      >
        {title}
      </h2>
      {subtitle ? (
        <p
          style={{
            ...designTokens.typography.bodyMd,
            color: designTokens.colors.onSurfaceVariant,
            marginTop: 0,
            marginBottom: designTokens.spacing.sm,
          }}
        >
          {subtitle}
        </p>
      ) : null}
      {children}
    </section>
  );
}
